<template>
  <div>
    <spinner :show="loading"></spinner>
  </div>
</template>

<script>
  import Spinner from 'components/spinner/spinner'

  export default {
    data () {
      return {
        loading: false
      }
    },
    components: {
      Spinner
    },
    created () {
      if (this.$from().isInner) {
        let cacheData = this.$parseParams(this.$cache.getCache())
        this.params = this.$route.query
        this.$cache.cache(this.$stringify(Object.assign({}, cacheData, this.params)))
        this._fetchData()
      } else {
        this.$router.replace('/auth/login')
      }
    },
    methods: {
      _fetchData () {
        let vm = this
        this.loading = true
        this.$ajax({
          url: '/wxURL.jhtml',
          params: vm.params,
          done (info) {
            vm.$cache.setUserToken({
              uid: info.uid,
              mac: info.mac
            })
            vm._forward(info.eventKey)
          },
          fail (m) {
            vm.$dialog({
              content: m,
              onConfirm () {
                window.WeixinJSBridge.call('closeWindow')
              }
            })
          },
          always () {
            vm.loading = false
          }
        })
      },
      _forward (key) {
        let path = '/'
        switch (key) {
          case '1002':
            path = '/consultant/appointment'
            break
          case '2001_1':
            path = '/auth/login'
            this.$cache.removeUserToken()
            break
          case '2001_2':
            path = '/auth/register'
            this.$cache.removeUserToken()
            break
          case '2001_3':
            path = '/user'
            break
          case '2001_4':
            path = '/user/unbind'
            break
        }
        this.$router.replace(path)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// forward.vue?28af0727